import React, { createContext, useContext, useState, useEffect } from "react";

const BasketContext = createContext(null);
const KEY = "bnm_basket";

export function BasketProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (p) =>
    setItems((prev) => {
      const found = prev.find((x) => x.id === p.id);
      if (found) return prev.map((x) => (x.id === p.id ? { ...x, qty: x.qty + 1 } : x));
      return [...prev, { id: p.id, name: p.name, price: p.price, unit: p.unit || "", slug: p.slug, image: p.images?.[0] || "", qty: 1 }];
    });
  const remove = (id) => setItems((prev) => prev.filter((x) => x.id !== id));
  const setQty = (id, qty) => setItems((prev) => prev.map((x) => (x.id === id ? { ...x, qty: Math.max(1, qty) } : x)));
  const clear = () => setItems([]);

  const addMany = (list) =>
    setItems((prev) => {
      const map = new Map(prev.map((x) => [x.id, { ...x }]));
      for (const p of list || []) {
        const q = p.qty || 1;
        if (map.has(p.id)) map.get(p.id).qty += q;
        else map.set(p.id, { id: p.id, name: p.name, price: p.price, unit: p.unit || "", slug: p.slug, image: p.images?.[0] || p.image || "", qty: q });
      }
      return [...map.values()];
    });

  const count = items.reduce((s, x) => s + x.qty, 0);
  const total = items.reduce((s, x) => s + x.qty * (x.price || 0), 0);

  return (
    <BasketContext.Provider value={{ items, add, addMany, remove, setQty, clear, count, total }}>
      {children}
    </BasketContext.Provider>
  );
}

export const useBasket = () => useContext(BasketContext);
